import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { LoadingPlaceHolder } from '../LoadingPlaceholder';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const PurchaseMotionContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "300",
    marginBlockEnd: "500",
    blockSize: "40px",
    children: children && children
  });
};
export const PurchaseMotionWrapper = ({
  columnConfig
}) => {
  var _columnConfig$price, _window$hubspot;
  const {
    isUpgradePoint,
    onPurchaseMotionButtonClick,
    purchaseMotionLocation,
    revenueAttributionUniqueId,
    displayOptions
  } = useFeatureTableSessionCache();
  if ((displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.showPurchaseMotion) === false) {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {});
  }
  if (columnConfig.purchaseMotion === undefined) {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      children: /*#__PURE__*/_jsx(LoadingPlaceHolder, {
        width: 100,
        height: 40
      })
    });
  }
  if (columnConfig.purchaseMotion === null) {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {});
  }
  if (columnConfig.purchaseMotion === 'CURRENT_PLAN') {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "feature-monetization.featureTable.currentPlan"
        })
      })
    });
  }
  const purchaseRequest = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.buyingMotionProps;
  const buyingProps = purchaseRequest && columnConfig.purchaseOption ? {
    purchaseRequest,
    commitmentTerm: columnConfig.purchaseOption.commitmentTerm,
    paymentTerm: columnConfig.purchaseOption.paymentTerm
  } : {
    currencyCode: (_columnConfig$price = columnConfig.price) === null || _columnConfig$price === void 0 ? void 0 : _columnConfig$price.currencyCode
  };
  const hasInsufficientBuyingProps = columnConfig.purchaseMotion.toString().toLowerCase().includes('buy_') && (!purchaseRequest || !columnConfig.purchaseOption);
  return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
    children: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      isUpgradePoint: isUpgradePoint,
      ctaProps: Object.assign({}, buyingProps),
      onClick: onPurchaseMotionButtonClick,
      purchaseMotion: hasInsufficientBuyingProps ? 'TALK_TO_SALES_FALLBACK' : columnConfig.purchaseMotion,
      apiName: columnConfig.productApiName,
      location: purchaseMotionLocation,
      trackingData: {
        // @ts-expect-error bender will be available when this is called in app
        app: ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || '',
        screen: 'feature-table',
        uniqueId: revenueAttributionUniqueId || 'feature-monetization-category-header'
      }
    })
  });
};